import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const WorstStrip = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 0.75rem;
  margin-bottom: 1rem;

  @media (max-width: 1120px) {
    grid-template-columns: repeat(auto-fit, minmax(11rem, 1fr));
  }
`

export const WorstCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.75rem;
  background: ${tokens.surface.glass};
  backdrop-filter: blur(${tokens.blur});
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.card};
  box-shadow: ${tokens.shadow.card};
  cursor: pointer;
  transition: border-color ${tokens.motion.duration} ${tokens.motion.ease};

  &:hover {
    border-color: ${tokens.accent.glowBorder};
  }
`

export const WorstName = styled.span`
  font-size: ${tokens.font.label};
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${tokens.text.muted};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const WorstRate = styled.span<{ $color: string }>`
  font-size: 1.25rem;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  color: ${(props) => props.$color};
`

export const WorstSub = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`

export const LeagueFootnote = styled.div`
  display: flex;
  padding-top: 1rem;
`
